import { useMutation } from '@tanstack/react-query'
import React from 'react'
import { voiceCloning } from '../../service/list'

export const useVoiceCloning = () => {
  return useMutation({
    mutationKey: ['voice-cloning'],
    mutationFn: voiceCloning,
  })
}
